import React from "react";
import "./about.css"; // Separate CSS file for About Us page

const AboutUs = () => {
  return (
    <div id="about-container">
      {/* ===== Header ===== */}
      <header className="about-header">
        <div className="logo-left">
          <img
            src={`${process.env.PUBLIC_URL}/images/national emblem.png`}
            alt="National emblem"
          />
        </div>
        <div className="header-text">
          <h1>ग्रामपंचायत वलनी</h1>
          <h2>पं.स. नागपूर, जि. नागपूर</h2>
          <h3 className="tagline">महाराष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h3>
        </div>
      </header>

      {/* ===== Main Content ===== */}
      <main className="about-main">
        <h2 className="section-title">आमच्याबद्दल</h2>
        <p>
          <b>ग्रामपंचायत वलनी</b>, पं.स. नागपूर, जि. नागपूर, महाराष्ट्र सरकार अंतर्गत येणारी एक प्रमुख ग्रामपंचायत आहे.
          ही पंचायत गावातील सर्व विकास कामे, नागरी सुविधा आणि शासकीय योजना अंमलात आणण्याचे काम करते।
        </p>

        <div className="callout">
          <strong>:</strong> ग्रामपंचायत वलनी सतत गावाच्या विकासासाठी नविन तंत्रज्ञानाचा वापर करते।
        </div>

        <h3 className="sub-title">आमचे ध्येय</h3>
        <p>
          ग्रामपंचायत वलनीचा मुख्य उद्देश गावाच्या सर्वसामान्यांच्या जीवनमानात सुधारणा करणे,
          शासकीय योजना प्रभावीपणे अंमलात आणणे आणि गावातील नागरिकांपर्यंत आवश्यक सेवा पोहचवणे हा आहे।
        </p>

        <h3 className="sub-title">आमची जबाबदारी</h3>
        <ul>
          <li>ग्रामविकासाची योजना तयार करणे व अंमलबजावणी करणे।</li>
          <li>शिक्षण, आरोग्य, पाणीपुरवठा व स्वच्छता यासारख्या मूलभूत सुविधांचा विकास।</li>
          <li>नागरिकांच्या समस्या आणि शिकाया-निवेदनांना त्वरित प्रतिसाद देणे।</li>
          <li>सार्वजनिक सभांचे आयोजन करणे व ग्रामसभेतील निर्णय अंमलात आणणे।</li>
        </ul>

        <h3 className="sub-title">आमची टीम</h3>
        <p>
          ग्रामपंचायत वलनीच्या कार्यकारणीमध्ये सरपंच, उपसरपंच, सचिव,
          ग्रामपंचायत अधिकारी आणि सदस्य यांचा समावेश आहे, जे गावाच्या सर्व विकासकामांमध्ये सक्रिय सहभाग घेतात।
        </p>

        <h3 className="sub-title">आमचे मूल्य</h3>
        <ul>
          <li>पारदर्शकता</li>
          <li>जवाबदारी</li>
          <li>समर्पण</li>
          <li>नागरिकांना प्राधान्य</li>
        </ul>
      </main>

      {/* ===== Footer ===== */}
      <footer className="about-footer">
        <p>© 2025 ग्रामपंचायत वलनी, पं.स. नागपूर, जि. नागपूर</p>
      </footer>
    </div>
  );
};

export default AboutUs;
